import { useCallback } from "react";

import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header Checklist Entrega Lista.
 * 
 */

type Props = {
  descricao: string | null;
  onClearFilters: () => void;
  handleDescricaoChange: (novaDescricao: string | null) => void;
};

export const Header = ({
  descricao,
  handleDescricaoChange,
  onClearFilters,
}: Props) => {
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  // const ddlStatus: DropDown[] = [
  //   { id: 2, title: 'Todos' },
  //   { id: 0, title: 'Ativo' },
  //   { id: 1, title: 'Inativo' },
  // ];

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-2 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >

              <div className="w-[40%]">
                <DefaultInput
                  name='descricao'
                  label='Descrição'
                  value={descricao}
                  onChangeValue={handleDescricaoChange}
                />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}